var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('div'),_vm._v(" "),_c('div',{staticClass:"px-5"},[_c('v-layout',{staticClass:"ma-0",attrs:{"row":"","wrap":""}},_vm._l((_vm.items),function(item,k){return _c('v-flex',{key:k,attrs:{"xs6":""}},[_c('div',[_vm._v("\n            "+_vm._s(item)+"\n          ")]),_vm._v(" "),_c('div',[_vm._v("-")])])}),1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0db9fe1e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/ticket2/productandbranch/BranchDetail.vue
// module id = null
// module chunks = 